import classnames from 'classnames';
import React from 'react';

const SIMILAR_BREEDS_TITLE = 'Similar breed puppies';
const SIMILAR_BREEDS_SUBTITLE = 'See more puppies available near you.';

interface SimilarBreedsSectionProps {
  children?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string | null;
}

/**
 * Layout shell for the similar breeds module. The carousel renders this itself
 * rather than the other way around, since only it knows whether its own results
 * came back empty.
 */
export default function SimilarBreedsSection({
  children = null,
  footer = null,
  className = null
}: SimilarBreedsSectionProps) {
  return (
    <div className={classnames('SimilarBreedsSection bg-sand', className)}>
      <div className="ph5 pb4">
        <h4 className="font-serif font-24 lh-title mb1">
          {SIMILAR_BREEDS_TITLE}
        </h4>
        <p className="font-16 secondary lh-title">{SIMILAR_BREEDS_SUBTITLE}</p>
      </div>
      {/*
        The body slot is deliberately unpadded — the carousel bleeds to the
        viewport edge on mobile — while the header and footer are inset, so the
        shell owns their gutter.
      */}
      {children}
      {footer && <div className="ph5 pt4">{footer}</div>}
    </div>
  );
}
